import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  ref: "unVisitedComps",
  "data-bs-backdrop": "static",
  "data-bs-keyboard": "false",
  "aria-labelledby": "staticBackdropLabel",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("QuickSource UAD 3.6 Beta Notice")
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h4", null, "QuickSource UAD 3.6 Beta"),
  /*#__PURE__*/_createElementVNode("div", { class: "mt-3" }, " You are previewing the QuickSource UAD 3.6 Beta. You can import from your current MLS, however, only limited MLS sites have been fully verified. "),
  /*#__PURE__*/_createElementVNode("div", { class: "mt-3 fw-bold" }, " Please double-check your data before finalizing the information that will be transferred to the report. "),
  /*#__PURE__*/_createElementVNode("div", { class: "mt-1" }, " For example, dates can default to the first day of the month rather than the specific date. "),
  /*#__PURE__*/_createElementVNode("div", { class: "mt-3" }, " We will continue to verify additional MLS sites and expand support for more data elements. ")
], -1)
const _hoisted_6 = ["href", "target"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ModalHeader = _resolveComponent("ModalHeader")!
  const _component_ModalBody = _resolveComponent("ModalBody")!
  const _component_ModalFooter = _resolveComponent("ModalFooter")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_ModalHeader, null, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        }),
        _createVNode(_component_ModalBody, null, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        }),
        _createVNode(_component_ModalFooter, null, {
          default: _withCtx(() => [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.saveModalState && _ctx.saveModalState(...args)))
            }, " Got It "),
            _createElementVNode("a", {
              href: _ctx.getLink(),
              target: _ctx.getTarget(),
              class: "btn btn-outline-secondary"
            }, " Learn More ", 8, _hoisted_6)
          ]),
          _: 1
        })
      ])
    ])
  ], 512))
}